var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDIcon = function SvgDIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#F5F5F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.58 24.884C14.58 25.514 15.066 26 15.696 26H19.278C23.238 26 25.974 23.246 25.974 19.7V19.664C25.974 16.118 23.238 13.4 19.278 13.4H15.696C15.066 13.4 14.58 13.886 14.58 14.516V24.884ZM16.794 23.984V15.416H19.278C21.924 15.416 23.652 17.234 23.652 19.7V19.736C23.652 22.202 21.924 23.984 19.278 23.984H16.794Z",
    fill: "#171A20"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/d-icon.9b1d5d4cc75222dbaf27f4f505535a14.svg";